import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Vue from 'vue'

Vue.use(BootstrapVue, {
    BButton: {
        size: 'sm'
    },
    "formControls": {
        "size": "md"
    },
});

Vue.use(BootstrapVueIcons);


import VueElementLoading from "vue-element-loading";

Vue.component("VueElementLoading", VueElementLoading);